import React, { useState, useEffect } from 'react';
import './Ranking.css';
import { getBeltImage } from './utils/beltHelper';
import UserBadges from './components/UserBadges';
import './components/UserBadges.css';

function Ranking({ onClose }) {
  const [rankings, setRankings] = useState([]);
  const [filters, setFilters] = useState({ genero: '', pais: '', cinturon: '', edad: '' });

  const paises = [
    { code: 'ar', name: 'Argentina' }, { code: 'bo', name: 'Bolivia' }, { code: 'br', name: 'Brasil' },
    { code: 'cl', name: 'Chile' }, { code: 'co', name: 'Colombia' }, { code: 'cr', name: 'Costa Rica' },
    { code: 'cu', name: 'Cuba' }, { code: 'ec', name: 'Ecuador' }, { code: 'sv', name: 'El Salvador' },
    { code: 'es', name: 'España' }, { code: 'us', name: 'Estados Unidos' }, { code: 'gt', name: 'Guatemala' },
    { code: 'hn', name: 'Honduras' }, { code: 'mx', name: 'México' }, { code: 'ni', name: 'Nicaragua' },
    { code: 'pa', name: 'Panamá' }, { code: 'py', name: 'Paraguay' }, { code: 'pe', name: 'Perú' },
    { code: 'pr', name: 'Puerto Rico' }, { code: 'do', name: 'República Dominicana' }, { code: 'uy', name: 'Uruguay' },
    { code: 've', name: 'Venezuela' }, { code: 'kr', name: 'Corea del Sur' }
  ];

  const cinturones = [
    'Blanco', 'Blanco Punta Amarilla', 'Amarillo', 'Amarillo Punta Verde', 'Verde',
    'Verde Punta Azul', 'Azul', 'Azul Punta Roja', 'Rojo', 'Rojo Punta Negra',
    'Negro 1° Dan', 'Negro 2° Dan', 'Negro 3° Dan', 'Negro 4° Dan', 'Negro 5° Dan',
    'Negro 6° Dan', 'Negro 7° Dan', 'Negro 8° Dan', 'Negro 9° Dan - Gran Maestro'
  ];

  const fetchRankings = async () => {
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      if (filters.genero) params.append('genero', filters.genero);
      if (filters.pais) params.append('pais', filters.pais.toUpperCase());
      if (filters.cinturon) params.append('cinturon', filters.cinturon);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/profile/leaderboard?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        let data = await response.json();
        console.log('Ranking data:', data);
        
        if (filters.edad) {
          data = data.filter(user => {
            if (!user.edad) return false;
            if (filters.edad === 'infantil') return user.edad >= 5 && user.edad <= 12;
            if (filters.edad === 'juvenil') return user.edad >= 13 && user.edad <= 17;
            if (filters.edad === 'adulto') return user.edad >= 18 && user.edad <= 39;
            if (filters.edad === 'senior') return user.edad >= 40;
            return true;
          });
        }

        setRankings(data);
      } else {
        console.error('Error response:', response.status);
      }
    } catch (error) {
      console.error('Error al obtener ranking:', error);
    }
  };

  useEffect(() => {
    fetchRankings();
  }, [filters]);

  const getMedal = (pos) => {
    if (pos === 0) return '🥇';
    if (pos === 1) return '🥈';
    if (pos === 2) return '🥉';
    return `#${pos + 1}`;
  };

  const getEdad = (edad) => {
    return edad || null;
  };

  const clearFilters = () => setFilters({ genero: '', pais: '', cinturon: '', edad: '' });

  return (
    <div className="ranking-overlay" onClick={onClose}>
      <div className="ranking-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✕</button>
        
        <h2 className="ranking-title">🏆 RANKING GLOBAL</h2>

        <div className="filters-container">
          <div className="filter-group">
            <button className={`filter-btn ${!filters.genero ? 'active' : ''}`} onClick={() => setFilters({...filters, genero: ''})}>🏆 Todos</button>
            <button className={`filter-btn ${filters.genero === 'M' ? 'active' : ''}`} onClick={() => setFilters({...filters, genero: 'M'})}>👨 Hombres</button>
            <button className={`filter-btn ${filters.genero === 'F' ? 'active' : ''}`} onClick={() => setFilters({...filters, genero: 'F'})}>👩 Mujeres</button>
          </div>

          <select className="filter-select" value={filters.pais} onChange={(e) => setFilters({...filters, pais: e.target.value})}>
            <option value="">🌍 Todos los Países</option>
            {paises.map(p => <option key={p.code} value={p.code}>{p.name}</option>)}
          </select>

          <select className="filter-select" value={filters.edad} onChange={(e) => setFilters({...filters, edad: e.target.value})}>
            <option value="">🌟 Todas las Edades</option>
            <option value="infantil">👶 Infantil (5-12)</option>
            <option value="juvenil">🧒 Juvenil (13-17)</option>
            <option value="adulto">🧑 Adulto (18-39)</option>
            <option value="senior">👴 Senior (40+)</option>
          </select>

          <select className="filter-select" value={filters.cinturon} onChange={(e) => setFilters({...filters, cinturon: e.target.value})}>
            <option value="">🥋 Todos los Cinturones</option>
            {cinturones.map(c => <option key={c} value={c}>{c}</option>)}
          </select>

          <button className="clear-filters-btn" onClick={clearFilters}>🔄 Limpiar</button>
        </div>

        <div className="ranking-list">
          {rankings.length === 0 ? (
            <div className="empty-ranking">🏆 No hay resultados</div>
          ) : (
            rankings.slice(0, 10).map((user, idx) => (
              <div key={user.user_id} className={`ranking-card ${idx < 3 ? 'top-three' : ''}`}>
                <div className="rank-position">{getMedal(idx)}</div>
                <div className="rank-avatar">{user.avatar ? <img src={user.avatar} alt="avatar" /> : '🥋'}</div>
                <div className="rank-info">
                  <div className="rank-name">
                    {user.nombre}
                    {user.pais && <img src={`https://flagcdn.com/16x12/${user.pais.toLowerCase()}.png`} alt={user.pais} />}
                    {user.genero && <span>{user.genero === 'M' ? '👨' : '👩'}</span>}
                    <UserBadges user={user} size="small" />
                  </div>
                  <div className="rank-details">
                    {user.cinturon || 'Blanco'} • 
                    {getBeltImage(user.cinturon || 'Blanco') ? (
                      <img 
                        src={getBeltImage(user.cinturon || 'Blanco')} 
                        alt={`Nivel ${user.nivel}`} 
                        className="belt-image-ranking"
                        title={`Nivel ${user.nivel}`}
                      />
                    ) : (
                      <>Nivel {user.nivel}</>
                    )}
                    {user.edad && ` • ${user.edad} años`}
                  </div>
                </div>
                <div className="rank-stats">
                  <div>⚡ {user.xp} XP</div>
                  <div>🏆 {user.mejor_score}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Ranking;
